import { ArticleMeta, articleTag } from "./types";

const META: ArticleMeta = {
    slug: "kubernetes-monolith-scaling",
    section: "briefing",
    header: "Platform Architecture",
    title: "Kubernetes Scaling - From Monolith to Elastic Services",
    description: "A migration path from tightly coupled monolith to autoscaled services, without downtime.",
    tags: [
        articleTag("kubernetes.svg"),
        articleTag("docker.svg"),
        articleTag("grafana.svg"),
        articleTag("prometheus-svgrepo-com.svg"),
        articleTag("terraform.svg"),
    ],
    url: "/articles/kubernetes-monolith-scaling",
};

export default META;
